import {buildLocationCode} from "../../../Utils/buildLocationCode";
import isVehicleOlderThan from "../../../../context/utils/isVehicleOlderThan";

const fillAdvancedConfigByCompany = async (companies, values, productCodesData, companiesNames, polkoClientes) => {
    let advancedConfig = {};
    const locationCodes = await buildLocationCode(companiesNames, values.codigosLocalidad);

    for (let company of companies) {
        const companyCodesObj = productCodesData.find(item => item.id_aseguradora === company) ?? "";
        const discount = companyCodesObj?.descuentos?.general ?? "";
        switch (company) {
            case 1: //Sancor
                advancedConfig = {
                    ...advancedConfig,
                    "Sancor": {
                        ...(!polkoClientes && {
                            ...values.configuracionAvanzada.Sancor,
                            "codigos": companyCodesObj.codigos,
                            "comision": companyCodesObj.comisiones.general,
                            "tipoUso": "2",
                            "descuentoModelo": 99,
                        }),
                        "codSancorLocalidad": locationCodes.CodigoLocalidadSancor,
                        "fechaCotizacion": values?.configuracionAvanzada?.Sancor?.fechaCotizacion
                    }
                }
                break;
            case 2: //RUS
                advancedConfig = {
                    ...advancedConfig,
                    "RUS": {
                        ...(!polkoClientes && {
                            ...values.configuracionAvanzada.RUS,
                            "codigos": companyCodesObj.codigos,
                            "comision": companyCodesObj.comisiones.general,
                        }),
                        "codRUSLocalidad": locationCodes.CodigoLocalidadRUS,
                        "vigenciaDesde": values?.configuracionAvanzada?.RUS?.vigenciaDesde,
                        "vigenciaHasta": values?.configuracionAvanzada?.RUS?.vigenciaHasta,
                    }
                }
                break;
            case 7: //Rivadavia
                advancedConfig = {
                    ...advancedConfig,
                    "Rivadavia": {
                        ...(!polkoClientes && {
                            ...values.configuracionAvanzada.Rivadavia,
                            "codigos": companyCodesObj.codigos,
                            "comision": companyCodesObj.comisiones.general,
                            "descuentoEspecial": discount,
                            "ajusteAutomatico": 5,
                        }),
                        "codRivadaviaLocalidad": `${locationCodes.NombreLocalidadRivadavia}`,
                        "vigenciaDesde": values?.configuracionAvanzada?.Rivadavia?.vigenciaDesde,
                        "vigenciaHasta": values?.configuracionAvanzada?.Rivadavia?.vigenciaHasta,
                        grua: values.configuracionAvanzada.Rivadavia.grua ?? isVehicleOlderThan(values?.vehiculo?.anio ?? values?.motovehiculo?.anio, 15)
                    }
                }
                break;
            default:
                advancedConfig = {
                    ...advancedConfig
                }
                break;
        }
    }

    return advancedConfig;
}

export {fillAdvancedConfigByCompany};